const MINIMAL_PAGE_ITEM_COUNT = 7;

const pagination = (total, current, width) => {
  // if (width < MINIMAL_PAGE_ITEM_COUNT) {
  //   throw new Error(
  //     `Must allow at least ${MINIMAL_PAGE_ITEM_COUNT} page items`
  //   );
  // }
  // if (width % 2 === 0) {
  //   throw new Error(`Must allow odd number of page items`);
  // }
  if (total < width) {
    return [...new Array(total).keys()];
  }
  const left = Math.max(
    0,
    Math.min(total - width, current - Math.floor(width / 2))
  );
  const items = new Array(width);
  for (let i = 0; i < width; i += 1) {
    items[i] = i + left;
  }
  // replace non-ending items with placeholders
  if (items[0] > 0) {
    items[0] = 0;
    items[1] = "...";
  }
  if (items[items.length - 1] < total - 1) {
    items[items.length - 1] = total - 1;
    items[items.length - 2] = "...";
  }
  return items.map((item) => ({ key: Math.random(), number: item }));
};

export default pagination;
